import { Set } from '~commonInfra/utils/Set';
import { ISimulationDescriptionParams } from '~src/simulation/serverApi/requests/SetSimulationDescriptionRequest';

import { Messages } from '../../codegen/Localize';
import { ActionHelpers, standardActionErrorMsg, standardActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ISimulationDetailInfo } from '../models/ISimulationInfo';
import { Simulations } from '../resources/Simulations';
import { SimulationErrors } from '../services/SimulationErrors';

export namespace ChangeSimulationDescriptionAction {
  export function execute(simulation: ISimulationDetailInfo, newDescription: string): Promise<IResult> {
	const parameters: ISimulationDescriptionParams = {
		id: simulation.id,
        description: newDescription
	};

    return Simulations.setDescription(parameters).then((result: IResult) => {
        ActionHelpers.displayStandardToastsForResult(
          Set.singletonForIdItem(simulation),
          result,
          {
            success: standardActionSuccessMsg(Messages.editDescriptionSuccessful),
            error: standardActionErrorMsg(Messages.editDescriptionFailure),
          },
          (errorItem: IErrorItem<ISimulationDetailInfo>) => SimulationErrors.errorDetailsFor(errorItem)
        );
        return result;
    });
  }
}
